export function Marketplace() {
  return (
    <>
      <svg width="24" height="24px" fill="none">
        <use href="#icon-marketplace"></use>
      </svg>
      <svg width="0" height="0">
        <symbol id="icon-marketplace" viewBox="0 0 24 24">
          <g clipPath="url(#clip0_1276_94488)">
            <g id="Icon-Marketplace">
              <g id="Group-5">
                <g id="Icon-Marketplace_2">
                  <path
                    id="XMLID_90_"
                    d="M16.8067 9.62876C16.8067 9.45661 16.8067 9.30906 16.7812 9.13691C16.7812 9.13691 16.7812 9.13691 16.7812 9.11232C16.7812 8.81721 16.5261 8.57129 16.1945 8.57129C15.8884 8.57129 15.6078 8.81721 15.6078 9.11232C15.6078 9.13691 15.6078 9.13691 15.6078 9.1615C15.6333 9.30906 15.6588 9.45661 15.6588 9.60416C15.6588 11.6453 14.2303 13.293 12.4957 13.293C10.7612 13.293 9.33269 11.6453 9.33269 9.60416C9.33269 9.45661 9.3582 9.30906 9.38371 9.1615C9.38371 9.13691 9.38371 9.13691 9.38371 9.11232C9.38371 8.81721 9.12863 8.57129 8.79702 8.57129C8.46541 8.57129 8.21032 8.81721 8.21032 9.11232C8.21032 9.11232 8.21032 9.11232 8.21032 9.13691C8.18481 9.30906 8.18481 9.45661 8.18481 9.62876C8.18481 12.2847 10.0979 14.4488 12.4702 14.4488C14.868 14.4488 16.8067 12.2847 16.8067 9.62876Z"
                    fill="#1C94C1"
                  ></path>
                  <path
                    id="XMLID_89_"
                    d="M7.83668 5.63223V4.8835C7.83668 4.10981 8.36663 3.51083 9.02907 3.51083H15.9626C16.625 3.51083 17.1549 4.13477 17.1549 4.8835V5.63223H18.7227V4.85854C18.7227 3.1115 17.5082 1.71387 15.9846 1.71387H9.00699C7.50547 1.71387 6.26892 3.1115 6.26892 4.85854V5.63223H7.83668Z"
                    fill="#268DA4"
                  ></path>
                  <path
                    id="XMLID_86_"
                    d="M17.0666 4.65234H7.92495C5.95093 4.65234 4.35291 6.30093 4.35291 8.35568V18.5817C4.35291 20.6364 5.95093 22.285 7.92495 22.285H17.0666C19.0406 22.285 20.6386 20.6364 20.6386 18.5817V8.35568C20.6386 6.32482 19.0406 4.65234 17.0666 4.65234ZM18.5941 18.5339C18.5941 19.4418 17.8891 20.1586 17.0431 20.1586H7.94845C7.07894 20.1586 6.39743 19.4179 6.39743 18.5339V8.40346C6.39743 7.49555 7.10244 6.77877 7.94845 6.77877H17.0431C17.9126 6.77877 18.5941 7.51944 18.5941 8.40346V18.5339Z"
                    fill="#35A0C1"
                  ></path>
                </g>
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_1276_94488">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.924316)"
              ></rect>
            </clipPath>
          </defs>
        </symbol>
      </svg>
    </>
  );
}
